import { ApiService } from '../api';
import { URLS, UrlUtils } from '../urls';
export class CheckoutService extends ApiService {
    getCheckoutInfo(code) {
        const url = UrlUtils.insertValueToUrl(URLS.CHECKOUT_PRODUCT_INFO, code);
        return this.get(url).then(resp => resp.json());
    }
}
